import $ from 'jquery'
import { quizPlayer } from '../quiz_player'

const quizData = $('#quiz-player-data').data('json')
if (quizData) {
  $(document).ready(() => quizPlayer(quizData))
}
